import React, { useEffect, useState } from "react";
import ItemRow from "./ItemRow";

const ItemTableList = ({ item }) => {
  const [itemChildren, setItemChildren] = useState([]);

  // using effect to put item children Her
  useEffect(() => {
    setItemChildren(item.children);
}, [item]);

  return (
    <>
      <div className="container mx-auto border-t pb-8">
        <table className="w-full text-sm text-left text-gray-500">
          <thead className="text-xs text-gray-700 uppercase bg-gray-50">
            <tr>
              <th scope="col" className="px-6 py-3"></th>
              <th scope="col" className="px-6 py-3"></th>
              <th scope="col" className="px-6 py-3"></th>
              <th scope="col" className="px-6 py-3"></th>

              <th scope="col" className="px-6 py-3 text-right">
                إسم المنتج
              </th>
              <th scope="col" className="px-6 py-3 text-right">
                صورة المنتج
              </th>
            </tr>
          </thead>
          <tbody>
            {itemChildren.map((child) => {
              return <ItemRow key={child.id} child={child} />;
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ItemTableList;
